// Material Kit 2 React pages
import Management from "pages/Management";

export default function ManagementPage() {
  return <Management />;
}
